import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export const Overlay = ({ children, title, placement = "bottom" }) => {

    const popover = (
        <Popover id="popover-basic">
            <Popover.Content>
                {title}
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={["hover", "focus"]} placement={placement} overlay={popover}>
            {children}
        </OverlayTrigger>
    );
}